import React from 'react';

const PartnersLogoSection = ({ 
  title = "Partners",
  logos = [], 
  backgroundColor = '#FDFCFA'
}) => {
  // Responsive handling with useState and useEffect
  const [windowWidth, setWindowWidth] = React.useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );
  
  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    
    // Add event listener
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
    
      // Clean up
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  // Responsive breakpoints
  const isMobile = windowWidth <= 768;
  const isSmallMobile = windowWidth <= 480;

  // Default logos if none are provided
  const defaultLogos = [
    {
      id: 1,
      name: "Partner 1",
      logo: "https://firebasestorage.googleapis.com/v0/b/off-the-curriculum-8ef2a.appspot.com/o/website%2FLandingpage%2Foct-logo.png?alt=media&token=d95bb7ea-f536-443c-ba89-165fffa6f86a",
    },
    {
      id: 2,
      name: "Partner 2",
      logo: "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2Flogos%2Fmedical-research-council-logo.png?alt=media&token=ca91e8d4-052f-453f-9752-56369a416265",
    },
    {
      id: 3,
      name: "Partner 3",
      logo: "https://firebasestorage.googleapis.com/v0/b/off-the-curriculum-8ef2a.appspot.com/o/website%2FFooter%2FPurple_Badge_PolicyBee.webp?alt=media&token=eed7901b-7ce4-4cf2-8caa-65339ce55b61",
    },
    {
      id: 4,
      name: "Partner 4",
      logo: "https://firebasestorage.googleapis.com/v0/b/off-the-curriculum-8ef2a.appspot.com/o/website%2FLandingpage%2Flondon_youth_qm_bronze_accredited.png?alt=media&token=6da71fd5-a915-4497-92de-2eccd63bc68f",
    },
    {
      id: 5,
      name: "Partner 5",
      logo: "/api/placeholder/110/45",
    },
  ];

  // Use provided logos or default if none provided
  const displayLogos = logos.length > 0 ? logos : defaultLogos;

  const styles = {
    container: {
      paddingTop: isSmallMobile ? '1.5rem' : isMobile ? '2rem' : '2.5rem',
      paddingBottom: isSmallMobile ? '1.5rem' : isMobile ? '2rem' : '2.5rem',
      width: '100%',
      overflow: 'hidden',
    },
    horizontalRule: {
      height: '1px',
      background: 'rgba(31, 72, 76, 0.1)',
      width: '100%',
      maxWidth: '1200px',
      margin: '0 auto',
    },
    innerContainer: {
      maxWidth: '1200px',
      margin: '30px auto',
      padding: '0 20px',
    },
    title: {
      fontSize: isSmallMobile ? '16px' : '18px',
      color: 'rgb(31, 72, 76)',
      textAlign: 'center',
      marginBottom: '30px',
      fontWeight: '500',
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
    },
    logoGrid: {
      display: 'flex',
      flexWrap: isMobile ? 'wrap' : 'nowrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      maxWidth: '1000px',
      margin: '0 auto',
      gap: isMobile ? '20px' : '0',
    },
    logoItem: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: isMobile ? (isSmallMobile ? 'calc(50% - 10px)' : 'calc(33.33% - 14px)') : 'auto',
      maxWidth: isSmallMobile ? '140px' : isMobile ? '160px' : '200px',
      marginBottom: isMobile ? '20px' : '0',
      transition: 'transform 0.3s ease',
    },
    logoImage: {
      width: '100%',
      height: 'auto',
      maxHeight: isSmallMobile ? '40px' : isMobile ? '50px' : '60px',
      objectFit: 'contain',
    },
  };

  return (
    <>      
      <div style={styles.container}>
        <div style={styles.innerContainer}>          
          <div style={styles.logoGrid}>
            {displayLogos.map((logo) => (
              <div 
                key={logo.id}
                style={styles.logoItem}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <img 
                  src={logo.logo} 
                  alt={logo.name}
                  title={logo.name}
                  style={styles.logoImage} 
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PartnersLogoSection;